document.addEventListener("DOMContentLoaded", function () {
    const swiperPageNewsSlider = document.querySelectorAll(".news-slider-container");
    const swiperBannerSlider = document.querySelectorAll(".banner-slider-container");

    swiperPageNewsSlider.forEach((swiperPageNewsSliderEl) => {
        const swiperTabletColumns = swiperPageNewsSliderEl.getAttribute("data-columns-tablet");
        const swiperDesktopColumns = swiperPageNewsSliderEl.getAttribute("data-columns-desktop");

        const swiper = new Swiper(swiperPageNewsSliderEl, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 32,
            autoHeight: true,

            pagination: {
                el: ".swiper-pagination",
                enabled: true,
                clickable: true,
            },

            navigation: {
                enabled: true,
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },

            breakpoints: {
                576: {
                    slidesPerView: swiperTabletColumns,
                },
                992: {
                    slidesPerView: swiperDesktopColumns,
                },
            },
        });
    });

    swiperBannerSlider.forEach((swiperBannerSliderEl) => {
        const swiper = new Swiper(swiperBannerSliderEl, {
            loop: true,
            spaceBetween: 16,
            autoHeight: true,
			autoplay: {
			  	delay: 5000,
			},

            pagination: {
                el: ".swiper-pagination",
                enabled: true,
                clickable: true,
            },

            navigation: {
                enabled: true,
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    });
});
